var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_error",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.157,
    height: 20.444,
    viewBox: "0 0 23.157 20.444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u4E2D\\u30DE\\u30C9_1",
    "data-name": "\\u4E2D\\u30DE\\u30C9 1",
    d: "M20.666,20.976H3.52A3,3,0,0,1,.94,16.445L9.513,2a3,3,0,0,1,5.16,0l8.573,14.444a3,3,0,0,1-2.58,4.531Zm-9.777-5.831v2.916H13.3V15.145Zm0-10.495V13.4H13.3V4.65Z",
    transform: "translate(-0.514 -0.532)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon_error.9850f664244d614e5f4bc8f7db15c94e.svg";
export { ForwardRef as ReactComponent };